export default "<div>\n\t<ng-transclude></ng-transclude>\n</div>\n";